/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');
var GetLicenseIdentifiers = require('../../license-dashboard/services/GetLicenseIdentifiers');

var GetEntityLocations = require('../../common/services/GetEntityLocations');
var GetLicenseDashboard = require('../services/GetLicenseDashboard');
var GetAllLicenseStatus = require('../services/GetAllLicenseStatus');
var GetEntityDetails = require('../../entity-form/services/GetEntityDetails');
var GetLicenseDBA = require('../services/GetLicenseDBA');
var NonDepLicenseEditGeneralInformationView = require('../views/NonDepLicenseEditGeneralInformationView');

module.exports = function(entityId, licenseId) {
  NProgress.start();
  NProgress.set(0.6);
  var isEdit = 1;

  $.when(
    GetEntityIdentifiers(entityId),
    GetLicenseIdentifiers(licenseId),
    GetEntityLocations(entityId),
    GetLicenseDashboard(licenseId),
    GetAllLicenseStatus(),
    GetEntityDetails(entityId),
    GetLicenseDBA(licenseId, isEdit)
  )
    .done(function(
      entityIdentifiers,
      licenseIdentifiers,
      entityLocations,
      licenseDashboard,
      licenseStatuses,
      entityDetails,
      licenseDbas
    ) {
      NavUtils.navigate('nondep/entity/' + entityId + '/license/' + licenseId + '/edit-general-information');
      Scaffold.content.show(
        new NonDepLicenseEditGeneralInformationView({
          model: new Backbone.Model({
            entityId: entityId,
            licenseId: licenseId,
            entityIdentifiers: entityIdentifiers,
            licenseIdentifiers: licenseIdentifiers,
            entityLocations: entityLocations,
            licenseDashboard: licenseDashboard,
            licenseStatuses: licenseStatuses.status,
            entityDbas: entityDetails.dbas,
            licenseDbas: licenseDbas
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
